var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("office-city-search-base", {
    attrs: { type: _vm.type, "submit-url": _vm.submitUrl, i18n: _vm.i18n },
    scopedSlots: _vm._u([
      {
        key: "city-select",
        fn: function(ref) {
          var onChange = ref.onChange
          return [
            _c("city-select-google", {
              attrs: {
                i18n: {
                  placeholder: _vm.i18n.cityPlaceholder,
                  noResults: _vm.i18n.cityNoResults
                }
              },
              on: { input: onChange }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }